import { render, staticRenderFns } from "./host-set-CatalogueType.vue?vue&type=template&id=79795aad&scoped=true&"
import script from "./host-set-CatalogueType.vue?vue&type=script&lang=js&"
export * from "./host-set-CatalogueType.vue?vue&type=script&lang=js&"
import style0 from "./host-set-CatalogueType.vue?vue&type=style&index=0&id=79795aad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79795aad",
  null
  
)

export default component.exports